import React, { useState } from 'react';
import '../../App.css';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-material.css';
import { useTranslation } from 'react-i18next';
import CustomTooltip from './customTooltip'
import '../../style/gridTheme.scss';
import { TableRow } from '../../types/typedefinitons';
import { ColDef, CsvExportParams} from 'ag-grid-community';
import cellEditor from './cellEditor';
import customFilter from './customFilter'
import FirstCellRenderer from './first_cell_renderer'
import ResistanceCellRenderer from './resistance_cell_renderer'
import { CommandBar, ICommandBarItemProps, Dropdown, IDropdownOption, Stack } from 'office-ui-fabric-react'
//@ts-ignore
import * as ExcelJS from 'exceljs/dist/es5/exceljs.browser'
import * as FileSaver from 'file-saver'
import { AgGridEvent } from 'ag-grid-community/dist/lib/events';

// Start IE11
const rewritePattern = require('regexpu-core');
const {generateRegexpuOptions} = require('@babel/helper-create-regexp-features-plugin/lib/util');
require('core-js/modules/es.promise');
require('core-js/modules/es.string.includes');
require('core-js/modules/es.object.assign');
require('core-js/modules/es.object.keys');
require('core-js/modules/es.symbol');
require('core-js/modules/es.symbol.async-iterator');
require('regenerator-runtime/runtime');

const {RegExp} = global;
try {
  new RegExp('a', 'u');
} catch (err) {
  // @ts-ignore
  global.RegExp = function(pattern, flags) {
    if (flags && flags.includes('u')) {
      return new RegExp(rewritePattern(pattern, flags, generateRegexpuOptions({flags, pattern})));
    }
    return new RegExp(pattern, flags);
  };
  // @ts-ignore
  global.RegExp.prototype = RegExp.prototype;
}

// Ende IE11

const Table: React.FC<{columns:ColDef[], values:{[key:string]:any}, spChangeHandler:(id:number, newValue:string, rowData:TableRow, materialId:number)=>void, isAppAdmin:boolean, onLangChange:(lang:string)=>void, onDataRefresh:()=>void}> = (props) => {
  const { t } = useTranslation();
  const defaultHiddenColumnsState:string[] = []; 
  const [hiddenColumns, setHiddenColumns] = useState(defaultHiddenColumnsState);
  const [columnGroupNav, setColumnGroupNav] = useState<IDropdownOption[]>();
  const [agGridAPI, setAgGridAPI] = useState<AgGridEvent>();
  const [selectedEignung, setSelectedEignung] = useState<string[]>([]);
  const [selectedMaterials, setSelectedMaterials] = useState<string[]>([]);
  let minRowHeight = 80;
  let currentRowHeight:number;

  const eignung = [
    {text:t('key.suitable'), symbol: '+'},
    {text:t('key.suitableAnm'), symbol: '(+)'},
    {text:t('key.lsuitability'), symbol: 'o'},
    {text:t('key.lsuitabilityAnm'), symbol: '(o)'},
    {text:t('key.nsuitability'), symbol: '-'},
    {text:t('key.noInfo'), symbol: 'kA'}
  ]

  const eignungOptions = eignung.map(item => {
    return {key:item.symbol, text:item.symbol + ' ' + item.text}
  });


  const defaultColDef = {
    sortable: true,
    filterable:true,  
    tooltipComponent: "customTooltip",
    editable: props.isAppAdmin,
    filter:true
  }

  const columnTypes = {
    resistanceInfo:{},
    notEditable: {editable:false},
    noAutoSize: {},
    JSON:{}
  };

  const frameworkComponents = { customTooltip: CustomTooltip, MyCellEditor:cellEditor, customFilter:customFilter, ResistanceCellRenderer:ResistanceCellRenderer, FirstCellRenderer:FirstCellRenderer};

  let valueArr:{}[] = [] 
    Object.keys(props.values).forEach((value:string) => {
        valueArr.push(props.values[value])
  })

  // console.log('VALUES', props.values, valueArr)
  const handleGrid = (params:AgGridEvent) => {
    let rowData:any[] = [];
    params.api.forEachNode((node:any) => rowData.push(node.data));
    const checkColumnsVisible = (src:{}[]) => {
      src.forEach((column:any) => {
        const columnData = rowData.map(row => row[column.field]);
        const testColumEmpty = columnData.filter(n => n);

        if(testColumEmpty.length === 0){
          console.log('hide ', column)
          params.columnApi.setColumnVisible(column.colId, false);
          curHiddenColumns.push(column.headerName);
        }
        else{
          params.columnApi.setColumnVisible(column.colId, true);
        }
       
      })
    };
    
    setAgGridAPI(params);
    params.api.setFilterModel(null);
    minRowHeight = params.api.getSizesForCurrentTheme().rowHeight;
    currentRowHeight = minRowHeight;
    params.api.resetRowHeights();
    params.api.sizeColumnsToFit();
    
    // if(selectedMaterials.length === 0){
      const columnGroups = params.columnApi.getColumnGroupState();
      let activeMaterials:string[] = []
      const groupNav = columnGroups.filter((group:any) => {
        // const groupInfo = group.getDefinition();
        if(group.open){
          return true;
        }
        return false;
      }).map((group:any) => {
        const groupInfo = params.columnApi.getColumnGroup(group.groupId);
        if(groupInfo){
          activeMaterials.push(group.groupId as string);
        }
        return{ key: group.groupId as string, text: group.groupId as string, selected:true }
      });
      setColumnGroupNav(groupNav);
      setSelectedMaterials(activeMaterials)
    // }
   

    params.api.setColumnDefs(props.columns);

    let curHiddenColumns:string[] = [];
    if(props.columns){
    props.columns.forEach( (columnGroup:any) => {
      if(columnGroup.children){
        checkColumnsVisible(columnGroup.children)
      }
      else{
        checkColumnsVisible(columnGroup)
      }
    })
  }

    setHiddenColumns(curHiddenColumns);
    autoSizeColumns(params);

  };

  const handleCellChange = (params:any) => {
    if(params.newValue !== params.oldValue){
      console.log('HIER', params)
      const elementId = params.data[params.colDef.field + '_Id'];
      const newValue = params.newValue;
      props.spChangeHandler(elementId, newValue, params.data, params.colDef.colId);

    }
    // props.spChangeHandler();
  }

  const autoSizeColumns = (gridApi:any) => {
    let allColumnIds:string[] = [];
    gridApi.columnApi.getAllColumns().forEach(function(column:any) {
      if(column.colDef.type !== 'noAutoSize' && column.colDef.type.indexOf('noAutoSize') === -1)
        allColumnIds.push(column.colId);
    });
    gridApi.columnApi.autoSizeColumns(allColumnIds, false);
  }

  const tranlateFunc = (key:string) => {
    return t('table.gridLabels.' + key)
  }

  const rowHeightFunc = (params:any) => {
    return currentRowHeight;

  }


  const onPageSizeChanged = (event:React.FormEvent<HTMLSelectElement>) => {
    console.log(event.currentTarget.value)
    var value = event.currentTarget.value;
    (agGridAPI as any).api.paginationSetPageSize(Number(value));
  }

  const filterChangedFunc = (params:AgGridEvent) => {
   const columns = params.columnApi.getAllColumns();
   columns.forEach(column => {
    params.api.getFilterInstance(column.getColId(), (filter)=> {
      if(filter !== undefined){
        //@ts-ignore
        filter.onNewRowsLoaded();
      }

    })
   })
   onEignungSelectionChanged(undefined)
  }

  const onMaterialSelectionChanged = (ev?:React.FormEvent<HTMLDivElement>, option?:IDropdownOption) => {
    let children:{}[] = [];
    if(option && option.selected === false){
      let materialsSelected = selectedMaterials
      materialsSelected.splice(selectedMaterials.indexOf(option.key as string),1);
      console.log('T1', materialsSelected, selectedMaterials)
      setSelectedMaterials(materialsSelected)
      children = agGridAPI!.columnApi.getColumnGroup(option!.key as string).getChildren();
    }
    else{
      if(option){
        let materialsSelected = selectedMaterials;
        materialsSelected.push(option.key as string);
        console.log('T2', materialsSelected)
        setSelectedMaterials(materialsSelected)
      }
     
      const allColumns = agGridAPI?.columnApi.getAllColumns();
      if(allColumns){
        allColumns.forEach(column => {
          const newVisibility = selectedMaterials.indexOf(column.getParent().getColGroupDef().headerName as string) !== -1 || column.getParent().getColGroupDef().headerName === '' ? true : false;
          console.log(column.getParent().getColGroupDef().headerName, newVisibility)
          // if (column.getParent().getColGroupDef().headerName === option?.key){
            agGridAPI?.columnApi.setColumnVisible(column.getColId(), newVisibility);
          // }
        })
      }
    }

    children.forEach(column => {
      agGridAPI?.columnApi.setColumnVisible((column as any).colId, (option!.selected as boolean))
    });
    onEignungSelectionChanged(undefined);
  }

  const onEignungSelectionChanged = (ev:React.FormEvent<HTMLDivElement>|undefined, option?:IDropdownOption) => {
    let rowData:any[] = [];
    let curHiddenColumns: string[] = [];
    let curSelectedEignung = selectedEignung;
    
    if(option?.selected === true){
      curSelectedEignung.push(option.key as string);
    }
    else if(option){
      curSelectedEignung.splice(curSelectedEignung.indexOf(option.key as string), 1)
    }
    setSelectedEignung(curSelectedEignung);
    agGridAPI?.api.forEachNodeAfterFilter((node:any) => rowData.push(node.data));
    
    const checkColumnsVisible = (src:{}[]) => {
      src.forEach((column:any) => {
        if(column.colDef.type === 'resistanceInfo'){
          const columnData = rowData.map(row => row[column.colDef.field]);
          const testColumEmpty = columnData.filter((n) => {
           if(curSelectedEignung.indexOf(n) !== -1 || curSelectedEignung.length === 0)
            return n
          });
          if(testColumEmpty.length === 0){
            // console.log('hide ', column)
            agGridAPI?.columnApi.setColumnVisible(column.colId, false);
            curHiddenColumns.push(column.colDef.headerName);
          }
          else if(selectedMaterials.indexOf(column.parent.groupId) !== -1){
            agGridAPI?.columnApi.setColumnVisible(column.colId, true);
          }
        }       
      });
      setHiddenColumns(curHiddenColumns);
    };

    const columns = agGridAPI?.columnApi.getAllColumns();
    if(columns){
      console.log('Selected:', selectedMaterials)
      checkColumnsVisible(columns)
    
    }
  }

  const onCSVExport = (event:any, columnSeparator:string, excel?:boolean) => {

    const CSVOptions:CsvExportParams = {
      columnSeparator:columnSeparator,
      fileName: 'GEMÜ Resistance information',
      customHeader: [[{data:{value:t('disclaimer.internalInformation')}}], [{data:{value:t('disclaimer.textCSV')}}]],
      processHeaderCallback: (params:any) => {
        const headerName = params.column.colDef.headerName;
        const headerTooltip = params.column.colDef.headerTooltip;
        return "'" + headerName + ( headerTooltip ? ' | ' + headerTooltip : '') + "'";
      }, 
      processCellCallback: (data:any) => {
        let result = '';
        if(data.value){
          result = data.value
          if(data.column.colDef.type.indexOf('JSON') !== -1){
            const content = JSON.parse(data.value);
            let fieldValues:string[] = [];
            Object.keys(content).forEach(val => {
              if (content[val] !== '' && content[val] !== null){
                fieldValues.push(content[val]);
              }
            });
            return fieldValues.join(' | ');
          }
        }
        if(data.column.colDef.tooltipField && data.column.colDef.tooltipField !== ''){
          const tooltipField = data.column.colDef.tooltipField;
          const tooltipValue = data.node.data[tooltipField];
          if(tooltipValue){
            result = ' ' + data.value + ' ' + tooltipValue;
            console.log(result)
          }
        }
        return result;
      } 

    }

    const ExcelOptions:CsvExportParams = {
      columnSeparator:columnSeparator,
      processHeaderCallback: (params:any) => {
        const headerName = params.column.colDef.headerName;
        const headerTooltip = params.column.colDef.headerTooltip;
        return headerName + ( headerTooltip ? ' | ' + headerTooltip : '');
      }, 
      suppressQuotes:true,
      processCellCallback: (data:any) => {
        let result = '';
        if(data.value){
          result = data.value
          if(data.column.colDef.type.indexOf('JSON') !== -1){
            const content = JSON.parse(data.value);
            let fieldValues:string[] = [];
            Object.keys(content).forEach(val => {
              if (content[val] !== '' && content[val] !== null){
                fieldValues.push(content[val]);
              }
            });
            return fieldValues.join(' | ');
          }
        }
        if(data.column.colDef.tooltipField && data.column.colDef.tooltipField !== ''){
          const tooltipField = data.column.colDef.tooltipField;
          const tooltipValue = data.node.data[tooltipField];
          if(tooltipValue){
            result = ' ' + data.value + ' ' + tooltipValue.replace(/\n/g,' - ');
          }
        }
        return result;
      } 

    }

    event.preventDefault();
    if(excel){
      const csvData = agGridAPI?.api.getDataAsCsv(ExcelOptions);
      convertToExcel(csvData);
    }
    else{
      agGridAPI!.api.exportDataAsCsv(CSVOptions)
    }

  }

  const convertToExcel = (data:string|undefined) => {
    let workbook = new ExcelJS.Workbook();
    // const stamp = workbook.addImage({
    //   filename: './images/stamp.png',
    //   extension:'png'
    // })
    let disclaimerSheet = workbook.addWorksheet('Disclaimer');
    disclaimerSheet.addRow([t('disclaimer.internalInformation')]);
    disclaimerSheet.addRow([t('disclaimer.textCSV')]);
    disclaimerSheet.mergeCells('A2:P8');
    disclaimerSheet.getCell('A9').value = { text: t('Excel.goToTable'), hyperlink: '#\'GEMÜ resistance\'!A1' };
    disclaimerSheet.getCell('A9').font = {color:{argb:'d80000'}, size:16}
    disclaimerSheet.mergeCells('A9:P9')
    disclaimerSheet.getCell('A10').value = t('Excel.CreationTime') + ': ' + new Date().toLocaleString();
    disclaimerSheet.mergeCells('A10:P10');
    disclaimerSheet.getCell('A1').font = {
      size:16,
      bold:true,
      color:{ argb: 'd80000' }
    }
    disclaimerSheet.getCell('A2').alignment = {
      wrapText:true,
      vertical:'top'
    }
    // disclaimerSheet.addImage(stamp, 'Q1:S3');
    
    let dataSheet = workbook.addWorksheet('GEMÜ resistance');
    dataSheet.views = [
      {state: 'frozen', xSplit: 4, ySplit: 1}
    ];
    dataSheet.autoFilter = 'A1:AT1';
    if(data) {
      const rows = data.split('\n');
      rows.forEach(row => {
        dataSheet.addRow(row.split(',,')); 
      });
      const columnCount = dataSheet.columnCount;
      console.log(columnCount);
      const headerRow = dataSheet.getRow(1);
      for(let i = 1; i <=columnCount; i++){
        headerRow.getCell(i).alignment = { textRotation: 90, horizontal:'left' };
      }
      
    // let ts = workbook.addWorksheet('Table');
    // const excelColumns = rows[0].split(',,').map((column, index) => {
    //   return {name:column, filterButton:true}
    // });
    // const excelRows = rows.map((row, index) => {
    //     // if(index > 0){
    //       return row.split(',,');
    //     // }
    //     // else
    //       // return {}
    //   })
    // console.log(excelColumns);
    // console.log(excelRows);

    // ts.addTable({
    //   name: 'MyTable',
    //   ref: 'A1',
    //   headerRow: true,
    //   style: {
    //     showRowStripes: true,
    //   },
    //   columns: excelColumns,
    //   rows: excelRows
    // });
  }
    workbook.xlsx.writeBuffer()
    .then(function(buffer:any) {
    const fileName = 'GEMÜ_resistance_information_' + new Date().toLocaleDateString() + '.xlsx';
     FileSaver.saveAs(new Blob([buffer]),fileName);
    });
  }

  let adminItems:ICommandBarItemProps[] = [];
  if(props.isAppAdmin) {
    adminItems = [{
      key: 'Refresh',
      text: t('buttons.refreshData'),
      iconProps: { iconName: 'Refresh' },
      onClick: () => {props.onDataRefresh()}
  }]
  }


  const publicItems: ICommandBarItemProps[] = [
    {
      key: 'downloadCSV',
      text: t('buttons.exportExcel'),
      cacheKey: 'myCacheKey', // changing this key will invalidate this item's cache
      iconProps: { iconName: 'ExcelLogo' },
      onClick: (event) => {onCSVExport(event, ',,', true)},
      split:true,
      subMenuProps: {
        items: [
          {
            key: ';',
            text: t('CSVOption.Semikolon'),
            onClick: (event) => {onCSVExport(event, ';')}
          },
          {
            key: ',',
            text: t('CSVOption.Comma'),
            onClick: (event) => {onCSVExport(event, ',')}
          },
        ],
      },
    },
    {
      key: 'Language',
      text: t('buttons.language'),
      cacheKey: 'myCacheKey', // changing this key will invalidate this item's cache
      iconProps: { iconName: 'LocaleLanguage' },
      subMenuProps: {
        items: [
          {
            key: 'DE',
            text: 'Deutsch',
            onClick: () => {props.onLangChange('DE')}
          },
          {
            key: 'EN',
            text: 'English',
            onClick: () => {props.onLangChange('EN')}
          },
        ],
      },
    }];

    //Wenn nicht im SharePoint Link zur Homepage einbelenden;
    //@ts-ignore
    if(typeof  g_wsaLCID === 'undefined' && window.location.href.indexOf('sp.gemue.biz') !== -1){
      publicItems.push({ 
        key: 'Homepage',
        text: 'GEMÜpedia Homepage',
        iconProps: { iconName: 'Home' },
        href: "https://sp.gemue.biz/gemuepedia"
      })
    }


    const _items = [...publicItems, ...adminItems]

  return (
    <>
    <div style={{borderBottom: '1px solid #ccc', margin:'10px 0 15px 0'}}>
    <CommandBar
        items={_items}
      />
      </div>

    <div className="gemu-rs-key-overview">
    <span className="gemu-rs-key-overview-item"><b>{t('key.title')}</b></span>
    {eignung.map(item => {
      return <span className="gemu-rs-key-overview-item" key={item.symbol}>{item.symbol} {item.text}</span>
    })}
    <span className="gemu-rs-key-overview-item"><b><a href="#key">{t('key.completeKey')}</a></b></span>
    </div>
    <Stack horizontal tokens={{childrenGap:40}}>
    {columnGroupNav && columnGroupNav.length > 0 ?
    <Dropdown
      placeholder={t('placeholder.materialCategory')}
      label={t('labels.materialCategory')}
      onChange={onMaterialSelectionChanged}
      multiSelect
      options={columnGroupNav}
    /> : 
    null }
    {eignungOptions ? 
    <Dropdown
      placeholder={t('placeholder.filterEignung')}
      label={t('labels.filterEignung')}
      onChange={onEignungSelectionChanged}
      multiSelect
      options={eignungOptions}
    /> : null 
    }
    </Stack>
    <div style={{ width: "100%", height: "100%" }}>
    <div
        className="ag-theme-material"
        id ="myGrid"
        style={{
        width: '100%', height:'85vh' }}
      >
        <div style={{margin:'8px 0'}}>
        <label htmlFor="changePagination">
          {t('table.itemsPerPage')} 
        <select id="changePagination" defaultValue={10} onChange={onPageSizeChanged}>
          <option>10</option>
          <option>25</option>
          <option>50</option>
          <option>100</option>
        </select>
        </label>

        </div>

        <AgGridReact
          columnDefs={props.columns}
          columnTypes = {columnTypes}
          defaultColDef={defaultColDef}
          rowData={valueArr}
          // domLayout='autoHeight'
          onRowDataChanged={handleGrid}
          // onCellClicked={handleCellClick}
          // singleClickEdit={true}
          onCellValueChanged={handleCellChange}
          pagination={true}
          paginationPageSize={10}
          localeTextFunc={tranlateFunc}
          frameworkComponents ={frameworkComponents}
          enableBrowserTooltips={true}
          suppressColumnVirtualisation={true}
          stopEditingWhenGridLosesFocus ={true}
          onGridReady = {(params) => {handleGrid(params);}}
          getRowHeight = {rowHeightFunc}
          onFilterChanged = {filterChangedFunc}
        />
      </div>
      </div>
      {hiddenColumns.length > 0 ? <p className="gemu-rs-hidden-columns-text">{t('infoText.hiddenColumns')} <b>{hiddenColumns.join(', ')}</b>.</p> : null}
      {/* <Stack horizontal tokens={{childrenGap:40}}> */}
        <div>
          <h3 id="key">{t('key.title')}</h3>
          <div className="gemu-rs-key">
            <div className="gemu-rs-key-row"><div className="gemu-rs-key-cell"><b>{t('key.Eignung')}</b></div><div className="gemu-rs-key-cell"></div></div>
            {eignung.map(item => {
              return <div className="gemu-rs-key-row" key={item.symbol}><div className="gemu-rs-key-cell">{item.symbol}</div><div className="gemu-rs-key-cell">{item.text}</div></div>
            })}
            <div className="gemu-rs-key-row"><div className="gemu-rs-key-cell"><b>{t('table.head.Konzentration')}</b></div><div className="gemu-rs-key-cell"></div></div>
            <div className="gemu-rs-key-row"><div className="gemu-rs-key-cell">TR</div><div className="gemu-rs-key-cell">{t('key.TR')}</div></div>
          </div>
        </div>
        <div style={{maxWidth:'80%'}}>
          <h3>{t('key.DeRatingFactorTitle')}</h3>
          <p>{t('key.DeRatingFactorText')}</p>
        </div>
      {/* </Stack> */}
      </>
  );
}

export default Table;
